import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=55f9f351&scoped=true&"
import script from "./Documentation.vue?vue&type=script&lang=js&"
export * from "./Documentation.vue?vue&type=script&lang=js&"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=55f9f351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9f351",
  null
  
)

export default component.exports